/**
 * 悬浮按钮 —— App内打开
 */
import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import { quotedata } from "../quotedata"
import { goAppAuto, isBaidu, isIOS, isWeChat } from "../utils"
import "./index.less"

export function OpenInApp(props: { type: string; quotedata: quotedata }) {
  const { code, market } = props.quotedata
  let isWx = isWeChat()

  const openInApp = () => {
    try {
      if (!isWx) {
        if (props.type == "zx") {
          window.location.href = "https://emstatic.eastmoney.com/awaken/app/share.html?linktype=818&stockCode=" + code + "&market=" + market + "&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0005084a"
        } else if (props.type == "page") {
          let shareId = ""
          if (isIOS()) {
            shareId = encodeURIComponent(`eastmoney://page/stockpage?code=${code}&market=${market}`)
          } else {
            shareId = encodeURIComponent(`dfcft://stock?market=${market}&code=${code}`)
          }
          let mdtype = ""
          if (location.search.indexOf("appfenxiang=1") > -1) {
            mdtype = "gghq"
            window.location.href = "https://mlink.eastmoney.com/h52n/nlink.html" + `?type=localurl&id=${shareId}&mdtype=${mdtype}`
          } else {
            window.location.href = "https://mlink.eastmoney.com/h52n/nlink.html" + `?type=localurl&id=${shareId}&curl=xxlout_dfcfappdfcfWAP_random_0005086a`
          }
        }
      }
    } catch (error) {}
    try {
      // 大数据埋点
      window.sendTrackLog("div", "click", "ggxqy_fb_tzapp")
    } catch (error) {}
  }

  useEffect(() => {
    if(isWx){
      if ($("#wx_open_app")) {
        $("#wx_open_app").html(`<wx-open-launch-app
          id="launch-btn"
          appid="wxb062331269cec15f" extinfo=${isIOS() ? `eastmoney://page/stockpage?code=${code}&market=${market}` : `dfcft://stock?market=${market}&code=${code}`}
          style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
              ">
          <script type="text/wxtag-template">
              打开东方财富App打开东方财富App打开东方财富App打开东方财富打开东方财富App打开东方财富App打开东方财富App打开东方财富打开东方财富App打开东方财富App打开
          </script>
        </wx-open-launch-app>`)
      }
    }
    setTimeout(() => {
      // 一个窗口只能自动唤起APP一次
      if (!sessionStorage.getItem("isAutoApp")) {
        sessionStorage.setItem("isAutoApp", "true")
        goAppAuto(props.quotedata.market, props.quotedata.code)
      }
    }, 1000)
  }, [])

  useEffect(() => {
    let btn = document.querySelector("#launch-btn") as HTMLDivElement
    if(isWx && btn){
      // console.log('开始唤起')
      btn.addEventListener("launch", (e: any) => {
        console.log("====== 唤起APP: 已成功唤起 ======", e.detail)
      })
      btn.addEventListener("error", function (e: any) {
        console.log("====== 唤起APP: 唤起失败 ======", e.detail)
        let mdtype = ""
        if (location.search.indexOf("appfenxiang=1") > -1) {
          mdtype = "gghq"
          window.location.href = "https://mlink.eastmoney.com/h52n/nlink.html" + `?type=localurl&id=${encodeURIComponent(isIOS() ? `eastmoney://page/stockpage?code=${code}&market=${market}` : `dfcft://stock?market=${market}&code=${code}`)}&mdtype=${mdtype}`
        } else {
          window.location.href = "https://mlink.eastmoney.com/h52n/nlink.html" + `?type=localurl&id=${encodeURIComponent(isIOS() ? `eastmoney://page/stockpage?code=${code}&market=${market}` : `dfcft://stock?market=${market}&code=${code}`)}&curl=xxlout_dfcfappdfcfWAP_random_0005086a`
        }

      })
    }
  }, [])

  return ReactDOM.createPortal(
    <>
      {!isBaidu() && (
      // {!isWx && !isBaidu() && (
        <>
          <a
            className={`open-inapp ${isWx ? "wx-open-inapp":""}`}
            href="#"
            onClick={(e) => {
              e.preventDefault()
              openInApp()
            }}
          >
            <i></i>APP内打开
            {isWx && <div id="wx_open_app" />}
          </a>
        </>
      )}
    </>,
    document.body
  )
}
